import React from "react";
import { ArrowUpOutlined } from "@ant-design/icons";
import { Button, Input, Tooltip } from "antd";

import "./AIAnalyticsPromptComposer.css";

const { TextArea } = Input;

/** Renders the prompt input textarea and send button. @param {string} promptText - current prompt value; @param {Function} onPromptChange - updates prompt text; @param {Function} onSendPrompt - submits the prompt */
export default function AIAnalyticsPromptComposer({
  promptText,
  onPromptChange,
  onSendPrompt,
}) {
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      if (promptText.trim()) {
        onSendPrompt();
      }
    }
  };

  return (
    <div className="AIAnalyticsPromptComposer">
      <h2>What can I help you analyze?</h2>
      <div className="AIAnalyticsPromptComposer__TextareaWrap">
        <TextArea
          autoSize={{ minRows: 4, maxRows: 8 }}
          value={promptText}
          onChange={(event) => onPromptChange(event.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Ask Anything..."
          className="AIAnalyticsPromptComposer__Textarea"
        />
        <Tooltip title="Send Prompt">
          <Button
            type="primary"
            shape="circle"
            icon={<ArrowUpOutlined />}
            className="AIAnalyticsPromptComposer__SendButton"
            disabled={!promptText.trim()}
            onClick={onSendPrompt}
          />
        </Tooltip>
      </div>
    </div>
  );
}
